import {
  AiChipIcon,
  AlarmClockIcon,
  Analytics01Icon,
  AtIcon,
  AudioWave01Icon,
  BarChartIcon,
  BookmarkAdd01Icon,
  BookOpen01Icon,
  BookOpenIcon,
  Brain02Icon,
  BrainIcon,
  BubbleChatAddIcon,
  BubbleChatIcon,
  Calendar03Icon,
  Call02Icon,
  ChartBarLineIcon,
  ChartIncreaseIcon,
  ChartLineData01Icon,
  CheckListIcon,
  CheckmarkCircle01Icon,
  Clock01Icon,
  CodeIcon,
  CommandIcon,
  ComputerTerminal01Icon,
  ConnectIcon,
  Contact01Icon,
  Copy01Icon,
  CursorIcon,
  DashboardBrowsingIcon,
  DashboardSquare01Icon,
  DatabaseIcon,
  DiscordIcon,
  DocumentAttachmentIcon,
  Download01Icon,
  Download02Icon,
  Edit01Icon,
  Edit02Icon,
  EyeIcon,
  FavouriteIcon,
  File01Icon,
  FilterIcon,
  FlashIcon,
  FlowCircleIcon,
  Flowchart01Icon,
  FlowIcon,
  GitForkIcon,
  Github01Icon,
  Globe02Icon,
  GlobeIcon,
  GridViewIcon,
  Image01Icon,
  KeyboardIcon,
  LanguageCircleIcon,
  Layers01Icon,
  LayersIcon,
  LayoutGridIcon,
  LayoutIcon,
  LinkSquare01Icon,
  ListViewIcon,
  MagicWand01Icon,
  Mail01Icon,
  MessageMultiple01Icon,
  NotificationIcon,
  PackageOpenIcon,
  PaintBoardIcon,
  PasswordValidationIcon,
  PencilEdit01Icon,
  Pin02Icon,
  PlayIcon,
  PuzzleIcon,
  RepeatIcon,
  RouteIcon,
  Search01Icon,
  Share01Icon,
  ShieldIcon,
  ShieldUserIcon,
  SourceCodeCircleIcon,
  StarIcon,
  Tag01Icon,
  Target02Icon,
  TelegramIcon,
  Time04Icon,
  ToolsIcon,
  TouchInteractionIcon,
  Upload01Icon,
  UserCircleIcon,
  UserGroupIcon,
  UserIcon,
  UserSearch01Icon,
  VoiceIcon,
  WorkflowCircle06Icon,
  WorkflowCircleIcon,
  WorkflowSquare10Icon,
  Wrench01Icon,
  ZapIcon,
} from "@icons";
import type { ComponentType } from "react";

interface IconProps {
  size?: number;
  color?: string;
  className?: string;
}

const ICON_MAP: Record<string, ComponentType<IconProps>> = {
  // Feature icons
  BubbleChatIcon,
  Search01Icon,
  BrainIcon,
  Notification01Icon: NotificationIcon,
  Notification02Icon: NotificationIcon,
  Image01Icon,
  ComputerTerminal01Icon,
  SourceCodeSquareIcon: SourceCodeCircleIcon,
  LayoutGridIcon,
  CheckListIcon,
  Calendar02Icon: Calendar03Icon,
  Calendar03Icon,
  Mail01Icon,
  Target02Icon,
  AlarmClockIcon,
  Pin02Icon,
  DashboardSquare03Icon: LayoutGridIcon,
  WorkflowSquare10Icon,
  WorkflowCircle06Icon,
  Clock01Icon,
  LightningIcon: FlashIcon,
  FlashIcon,
  FileEditIcon: DocumentAttachmentIcon,
  DocumentAttachmentIcon,
  PackageIcon: PackageOpenIcon,
  PackageOpenIcon,
  IntegrationIcon: ConnectIcon,
  ConnectIcon,
  Store01Icon: Globe02Icon,
  Globe02Icon,
  ServerIcon: SourceCodeCircleIcon,
  SourceCodeCircleIcon,
  PuzzlePieceIcon: PuzzleIcon,
  PuzzleIcon,
  UserCircleIcon,
  BotIcon: UserGroupIcon,
  UserGroupIcon,
  Wrench01Icon,
  CustomIntegrationIcon: Wrench01Icon,
  MicrophoneIcon: Call02Icon,
  Call02Icon,
  MessageMultiple02Icon: MessageMultiple01Icon,
  MessageMultiple01Icon,
  GameboyIcon: DiscordIcon,
  DiscordIcon,
  AirplaneIcon: TelegramIcon,
  TelegramIcon,
  SmartPhone01Icon: BubbleChatIcon,
  PlusSignIcon: ConnectIcon,
  // Benefit icons — native
  ZapIcon,
  FlowIcon,
  Brain02Icon,
  ChartLineData01Icon,
  BubbleChatAddIcon,
  ShieldUserIcon,
  UserSearch01Icon,
  MagicWand01Icon,
  PencilEdit01Icon,
  CodeIcon,
  BarChartIcon,
  ChartRingIcon: BarChartIcon,
  Analytics01Icon,
  AiChipIcon,
  CheckmarkCircle01Icon,
  RepeatIcon,
  GlobeIcon,
  FavouriteIcon,
  LinkSquare01Icon,
  LinkSquare02Icon: LinkSquare01Icon,
  Copy01Icon,
  Share01Icon,
  ToolsIcon,
  File01Icon,
  Download02Icon,
  BookOpen01Icon,
  FlowCircleIcon,
  Flowchart01Icon,
  KeyboardIcon,
  Tag01Icon,
  Edit02Icon,
  PlayIcon,
  Contact01Icon,
  EyeIcon,
  // Additional benefit icons that exist natively
  BookmarkAdd01Icon,
  GitForkIcon,
  StarIcon,
  LayersIcon,
  AudioWave01Icon,
  DashboardSquare01Icon,
  DashboardBrowsingIcon,
  GridViewIcon,
  LanguageCircleIcon,
  WorkflowCircleIcon,
  ListViewIcon,
  Time04Icon,
  FilterIcon,
  Edit01Icon,
  ChartBarLineIcon,
  ChartIncreaseIcon,
  BookOpenIcon,
  DatabaseIcon,
  ShieldIcon,
  Github01Icon,
  PaintBoardIcon,
  Download01Icon,
  RouteIcon,
  Layers01Icon,
  VoiceIcon,
  AtIcon,
  CommandIcon,
  LayoutIcon,
  CursorIcon,
  TouchInteractionIcon,
  PasswordValidationIcon,
  UserIcon,
  Upload01Icon,
  // Aliases for missing icons
  BranchIcon: GitForkIcon,
  Zap01Icon: ZapIcon,
  BarChart01Icon: BarChartIcon,
  // Other common aliases used in data
  Calendar01Icon: Calendar03Icon,
  GlobalIcon: GlobeIcon,
  RefreshIcon: RepeatIcon,
  Bookmark01Icon: BookmarkAdd01Icon,
  ArrowRight01Icon: FlowCircleIcon,
};

interface FeatureIconProps {
  name: string;
  size?: number;
  color?: string;
}

export function FeatureIcon({
  name,
  size = 18,
  color = "#00bbff",
}: FeatureIconProps) {
  const Icon = ICON_MAP[name] ?? ZapIcon;
  return (
    <span style={{ color, display: "flex", alignItems: "center" }}>
      <Icon size={size} />
    </span>
  );
}
